import axios from "axios";
import { createContext, useEffect, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const accessToken = sessionStorage.getItem("token");
    const [userEmail, setUserEmail] = useState("");
    const [userProfile, setUserProfile] = useState({});

    const handleFetchUserProfile = async () => {
        const userId = sessionStorage.getItem("userId");
  
        try {
            const response = await axios.get(`/user/getUserProfile/${userId}`);
  
            if (response.status === 200) {
              setUserProfile(response.data.user)
              console.log("user profile alert", response.data.user)
              sessionStorage.setItem("userEmail", response.data.user.email)
            }
  
        } catch (err) {
            // if (err.response && err.response.status === 402) {
            //     } else {
                // Handle other errors if needed
                console.error("Error fetching user profile:", err);
                // Optionally set an error state to display a message to the user
            // }
  
        } finally {
        }
    };

    
   


    useEffect(() => {
        handleFetchUserProfile()
    }, []);

    return (
        <UserContext.Provider value={{
            accessToken,
            userProfile
        }}>
            {children}
        </UserContext.Provider>
    )
}